import { isUndefinedOrNull } from '../../TypeHelpers';
export default function any(array, predicate) {
    if (isUndefinedOrNull(predicate)) {
        return array.length > 0;
    }
    return array.some(predicate);
}
